import React from 'react';
import { useTranslator, useUrlLocalizer } from 'static/script/app/lang';
import UserIcon from '@tradera/blueprint/theme/icons2/user-fill.svg?jsx';
import TimeIcon from '@tradera/blueprint/theme/icons2/time.svg?jsx';
import FilterIcon from '@tradera/blueprint/theme/icons2/filter.svg?jsx';

// Dont blur input when there's a mouseclick on the search suggestions
const preventDefault = evt => {
    evt.preventDefault();
};

// Without this, the search field dropdown is collapsed. Fixes TWT-993.
const fixFlexHeightInIpadMini2Style = { flexBasis: 'auto' };

// https://github.com/facebook/react/issues/3386#issuecomment-291152357
const HighlightWord = ({ text, query = '', icon }) => {
    if (!text) {
        return;
    }
    if (!query) {
        return (
            <span>
                {icon && icon}
                {text}
            </span>
        );
    }
    return (
        <span className="font-weight-bold">
            {text.split(query).reduce((prev, current, i) => {
                if (!i) {
                    return [current];
                }
                return prev.concat(
                    <span
                        className={`font-weight-normal`}
                        key={query + current}>
                        {query}
                    </span>,
                    current
                );
            }, [])}
        </span>
    );
};

export const PreviousSearchesListItem = ({
    item,
    changeSearchTerm,
    searchTerm,
    isSelected,
    selectedCategoryId
}) => {
    const { toLocalizedUrl } = useUrlLocalizer();
    return (
        <a
            data-suggestion
            className={`list-group-item list-group-item-action slim-header__search-suggestion ${
                isSelected ? 'slim-header__search-suggestion--active' : ''
            }`}
            data-previous-suggestion={item.key}
            onClick={changeSearchTerm}
            onMouseDown={preventDefault}
            data-ga-category="Search box"
            data-ga-action="Navigation"
            data-ga-label="recent suggestion"
            href={toLocalizedUrl(
                `/search?q=${encodeURIComponent(item.key)}&categoryId=${
                    selectedCategoryId ? selectedCategoryId : 0
                }`
            )}>
            <HighlightWord
                className=""
                query={searchTerm}
                text={item.key}
                icon={<TimeIcon className="icon align-text-bottom mr-3" />}
            />
        </a>
    );
};

export const SearchesSuggestionsListItem = ({
    item,
    changeSearchTerm,
    searchTerm,
    isSelected,
    selectedCategoryId
}) => {
    const categoryId = item.category
        ? item.category.id
        : selectedCategoryId
        ? selectedCategoryId
        : 0;
    const { toLocalizedUrl } = useUrlLocalizer();
    return (
        <a
            data-suggestion
            className={`list-group-item list-group-item-action slim-header__search-suggestion ${
                isSelected ? 'slim-header__search-suggestion--active' : ''
            }`}
            data-search-suggestion={item.text}
            onClick={changeSearchTerm}
            onMouseDown={preventDefault}
            data-ga-category="Search box"
            data-ga-action="Navigation"
            data-ga-label={`${
                item.category ? 'category suggestion' : 'normal suggestion'
            }`}
            href={toLocalizedUrl(
                `/search?q=${encodeURIComponent(
                    item.text
                )}&categoryId=${categoryId}`
            )}>
            <HighlightWord query={searchTerm} text={item.text} />
            <i> {item.category ? `inom ${item.category.name}` : ''}</i>
        </a>
    );
};

export const ShopsSuggestionsListItem = ({
    item,
    changeSearchTerm,
    searchTerm,
    isSelected
}) => {
    const { toLocalizedUrl } = useUrlLocalizer();
    return (
        <a
            data-suggestion
            className={`list-group-item list-group-item-action slim-header__search-suggestion ${
                isSelected ? 'slim-header__search-suggestion--active' : ''
            }`}
            data-shop-suggestion={item.name}
            onClick={changeSearchTerm}
            onMouseDown={preventDefault}
            data-ga-category="Search box"
            data-ga-action="Navigation"
            data-ga-label="shop suggestion"
            href={toLocalizedUrl(
                `/profile/items/${item.memberId}/${item.urlName}`
            )}>
            <em className="badge badge-primary mr-2">Butik</em>
            <HighlightWord query={searchTerm} text={item.name} />
        </a>
    );
};

export const AdvancedSearchListItem = ({ isSelected }) => {
    const { t } = useTranslator();
    const { toLocalizedUrl } = useUrlLocalizer();
    return (
        <a
            href={toLocalizedUrl('/search/detailed')}
            data-suggestion
            data-advanced-search
            className={`list-group-item list-group-item-action slim-header__search-advanced underline slim-header__search-suggestion col-12 ${
                isSelected ? 'slim-header__search-suggestion--active' : ''
            }`}
            style={fixFlexHeightInIpadMini2Style}
            onMouseDown={preventDefault}>
            <FilterIcon className="icon align-text-bottom" />
            <span className="ml-3">{t('siteHeader_searchAdvanced')}</span>
        </a>
    );
};

export const SellerSearchListItem = ({ isSelected }) => {
    const { t } = useTranslator();
    const { toLocalizedUrl } = useUrlLocalizer();
    return (
        <a
            href={toLocalizedUrl(
                '/search/detailed/member?itm_source=nav&itm_medium=search-detailed-member'
            )}
            data-suggestion
            className={`list-group-item list-group-item-action slim-header__search-seller underline slim-header__search-suggestion col-12 ${
                isSelected ? 'slim-header__search-suggestion--active' : ''
            }`}
            style={fixFlexHeightInIpadMini2Style}
            onMouseDown={preventDefault}>
            <UserIcon className="icon align-text-bottom" />
            <span className="ml-3">{t('siteHeader_searchSeller')}</span>
        </a>
    );
};
